// Gerenciar kits
(function () {
  'use strict';

  // Variáveis
  const $formKit = $('.form-kits');
  const $secaoKits = $('.secao-kits');
  const $btnAddOpcao = $('[data-list-add="opcao"]');
  const $modalOpcao = $('#modal-opcao');
  const $formAddOpcao = $('#form-opcao');

  // Formulário de gerenciamento do kit
  if ($formKit.length > 0) {
    // Váriaveis
    const $imageKit = $('img.kit-product-image');
    const $listVariantes = $('[data-list="variantes_lista"]');
    const $listOpcoes = $('[data-list="opcoes_lista"]');
    const $imagesKitContainer = $('#imgs-kit');
    const $inptFotoId = $formKit.find('input[name="image_id"]');
    const $inptDisponibilidade = $formKit.find('input[name="disponibilidade"]');
    const $tableVariantesWrp = $('.table-variantes-kits-wrp');
    const $tableOpcoesWrp = $('.table-opcoes-wrp');
    const product_id = $formKit.find('input[name="product_id"]').val();
    const urlProduct = $formKit.attr('action');
    let imagesList = [];
    let totalImages = 0;

    // Adiciona opção na lista

    // Obtém a lista de imagens
    function getImages(product_id) {
      let url = urlProduct + `?acao=image_kits&product_id=${product_id}`;
      //console.log(url);
      $.ajax({
        url: url,
        type: 'GET',
        contentType: 'application/json',
        cache: false,
      })
        .done(function (resp) {
          try {
            resp = JSON.parse(resp);
            imagesList = resp.images;
            totalImages = imagesList.length;
            //console.log({ imagesList, totalImages });
            populateGalleryKits();
          } catch (error) {
            console.log(error);
          }
        })
        .fail(function (resp) {
          console.log(resp);
        });
    }
    getImages(product_id);

    // Popula galeria para seleção das variantes
    function populateGalleryKits() {
      $imagesKitContainer.html('');
      if (totalImages > 0) {
        for (let i = 0, n = totalImages; i < n; i++) {
          const image = imagesList[i];
          const $image = `
        <label class="col-6 col-md-3 img-check">
          <input type="radio" name="kit_img" value="${image.id}">
          <img src="${image.image_small}" class="img-fluid rounded">
        </label>`;
          $imagesKitContainer.append($image);
        }
      }
    }

    // Popula a tabela de variantes
    function updateVariantesTableKits(cb) {
      let listVariantesObj = $('#variantes_kit_json').val() ? JSON.parse($('#variantes_kit_json').val()) : [];
      formListClear($listVariantes);
      if (listVariantesObj.length > 0) {
        $tableVariantesWrp.show();
      } else {
        $tableVariantesWrp.hide();
      }
      listVariantesObj.forEach((variante) => {
        const variantInKit = variante['in_kit'] == '1';
        const nextID = formListGenerateID($listVariantes);
        const habilitado = $inptDisponibilidade.is(':checked');
        const tituloView = variante.title;
        const skuView = variante.sku;
        if (variantInKit == false) {
          var qtdeView = variante.automatic_stock == '1' ? variante.quantity : 1;
        } else {
          var qtdeView = variante.kit_quantity;
        }
        const qtdMax = variante.automatic_stock == '1' ? `max="${qtdeView}"` : `${qtdeView}`;
        const fotoView = variante['foto']['image_small'];
        const valorView = formatMoneyBR(variantInKit ? variante.kit_sale_price : variante.sale_price);
        const habilitedCheck = checkHabilitado(variante['in_kit']) ? 'checked' : '';
        const inputsStatus = checkHabilitado(variante['in_kit']) ? '' : 'disabled';
        //const statusSelect = habilitado == true ? 'disabled' : '';
        const statusSelect = '';
        const $variante = `
        <tr data-item="${nextID}" data-variante="${variante.slug}" data-sku="${variante.sku}">
          <td data-label="Checkbox">
            <div class="form-check">
              <input type="checkbox" class="form-check-input select-variant" id="select-variant-${variante.id}" value="${variante.id}" ${habilitedCheck} ${statusSelect}>
              <label class="form-check-label" for="select-variant-${variante.id}"></label>
              <input type="hidden" class="kit_input_sku" name="kit_items[${nextID}][variant_sku]" value="${skuView}" ${inputsStatus}>
              <input type="hidden" class="kit_input_id" name="kit_items[${nextID}][id]" value="${variante.id}">
            </div>
          </td>
          <td data-label="Foto" width="70px"><img src="${fotoView}" class="img-fluid border rounded" data-handle-variante-img="${variante.slug}" width="50px">
          </td>
          <td data-label="Variante"><div class="variante-tit">${tituloView}</div></td>
          <td data-label="Preço">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">R$</span>
              </div>
              <input type="text" name="kit_items[${nextID}][sale_price]" inputmode="numeric" class="form-control money kit_input_price" data-input-default="0,00" data-parsley-trigger="change" placeholder="0,00" value="${valorView}" data-required="true" required ${inputsStatus}>
            </div>    
          </td>
          <td data-label="Quantidade">
            <div class="input-group number-spinner">
              <div class="input-group-prepend">
                <button class="btn btn-default ns-sub"><i class="las la-minus"></i></button>
              </div>
              <input type="text" inputmode="numeric" name="kit_items[${nextID}][quantity]" class="form-control ns-input kit_input_quantity" data-input-default="0" min="0" ${qtdMax} data-parsley-trigger="change" value="${qtdeView}" data-required="true" required="" ${inputsStatus}>
              <div class="input-group-append">
                <button class="btn btn-default ns-add"><i class="las la-plus"></i></button>
              </div>
            </div>
          </td>
        </tr>`;
        $listVariantes.append($variante);
      });
      initTooltips();
      initInputMask();
      cb();
    }
    updateVariantesTableKits(() => {
      const $containerKitTotal = $('.container-kit-total');
      $containerKitTotal.show();
      $('tbody[data-list="variantes_lista"] tr').on('mouseenter', desabilitaMinMax);
    });

    function updateOpcoesTableKits(cb) {
      const listOpcoesObj = $('#opcoes_kit_json').val() ? JSON.parse($('#opcoes_kit_json').val()) : [];
      if (listOpcoesObj.length > 0) {
        $tableOpcoesWrp.show();
      } else {
        $tableOpcoesWrp.hide();
      }
      listOpcoesObj.forEach((opcao) => {
        const variants_json = JSON.parse(opcao.variants.replace(/\\/g, ''));
        var total = variants_json.reduce((total, current) => {
          const valor = Number(current['sale_price'].replace(',', ''));
          const quantity = Number(current['quantity']);
          //console.log(`Valor: ${valor} | Quantity: ${quantity}`);
          return total + valor * quantity;
        }, 0);
        total = formatMoneyBR(total);
        const quantity_opcao = variants_json.reduce((total, current) => {
          const valor = Number(current['quantity']);
          return total + valor;
        }, 0);
        const item = {
          titulo: opcao.title,
          variants: variants_json,
          quantidade: quantity_opcao,
          total: total,
          id: opcao.id,
          sku: opcao.sku ? opcao.sku : '',
        };
        addOpcaoLinha(item);
      });
    }
    updateOpcoesTableKits(() => {});

    // Ação para atualizar o campo total
    function getValorTotalOpcao() {
      const $tableVariantesWrp = $('.table-variantes-kits-wrp');
      const $kitValorTotal = $('.kit_valor_total');
      var total = 0;
      $tableVariantesWrp
        .find('tbody tr')
        .filter(function (index) {
          return $(this).find('.select-variant').is(':checked');
        })
        .each(function (index) {
          // linhas com checkbox habilitado
          const $rowVariant = $(this);
          const $inputPrice = $rowVariant.find('input.kit_input_price');
          const $inputQtd = $rowVariant.find('input.kit_input_quantity');
          //console.log(`Input price: ${$inputPrice.val()} e formatmoneydb: ${formatMoneyBD($inputPrice.val())}`);
          const inputPriceValue = Number(formatMoneyBD($inputPrice.val()));
          const inputQtdValue = Number($inputQtd.val());
          /* console.log(
            `inputprice: ${inputPriceValue} | qtde: ${inputQtdValue} | operação: ${inputPriceValue * inputQtdValue}`,
          ); */
          total += inputPriceValue * inputQtdValue;
        });
      total = formatMoneyBR(total);
      return total;
    }

    function getQuantidadeTotalOpcao() {
      const $tableVariantesWrp = $('.table-variantes-kits-wrp');
      let total = 0;
      $tableVariantesWrp
        .find('tbody tr')
        .filter(function (index) {
          return $(this).find('.select-variant').is(':checked');
        })
        .each(function (index) {
          const $rowVariant = $(this);
          //console.log($rowVariant[0]);
          const inputQtd = $rowVariant.find('input.kit_input_quantity');
          total += Number(inputQtd.val());
        });
      return total;
    }

    // Adiciona linha na opção
    function addOpcaoLinha(item) {
      const nextID = item.id ? item.id : formListGenerateID($listOpcoes);
      const viewMoneyTotal = item.total;
      if (nextID == 1) {
        $tableOpcoesWrp.show();
      }
      const itemSku = item.sku !== undefined ? item.sku : '';
      const $opcao = `
      <tr data-item="${nextID}" data-variants-json='${JSON.stringify(item.variants)}' data-opcao-titulo="${
        item.titulo
      }">
        <td data-label="Checkbox">
          <div class="form-check">
            <input type="checkbox" class="form-check-input select-opcao" name="opcao_status[${nextID}]" id="select-opcao-${nextID}" checked>
            <label class="form-check-label" for="select-opcao-${nextID}"></label>
          </div>
        </td>
        <td data-label="Opção" class="opcao-titulo">
          ${item.titulo}
        </td>
        <td data-label="Preço total" data-total="${viewMoneyTotal}"><div class="opcao-preco">R$ ${viewMoneyTotal}</div></td>
        <td data-label="Quantidade" class="opcao-quantidade">
          ${item.quantidade}
        </td>
        <td>
          <div class="table-options no-hover">
            <a href="#" class="btn btn-sm btn-default" data-toggle="tooltip" data-placement="bottom" title="Editar" data-edit-opcao="${nextID}"><i class="las la-pen"></i></a>

            <a href="#" class="btn btn-sm btn-danger" data-toggle="tooltip" data-placement="bottom" title="Remover" data-remove-opcao="${nextID}"><i class="las la-trash"></i></a>

            <input type="hidden" name="opcao_titulo[${nextID}]" class="input-opcao-titulo" value="${item.titulo}">
            <input type="hidden" name="opcao_sku[${nextID}]" class="input-opcao-sku" value="${itemSku}">
            <input type="hidden" name="variants[${nextID}]" class="input-opcao-variants" value='${JSON.stringify(
        item.variants,
      )}'>
          </div>
        </td>
      </tr>`;
      $listOpcoes.append($opcao);
      initTooltips();
    }

    // Edita linha da opção
    function editOpcaoLinha(item, idOpcao) {
      const $rowEdit = $listOpcoes.find(`[data-item=${idOpcao}]`);
      $rowEdit.data('variants-json', JSON.stringify(item.variants));
      $rowEdit.find('input[name="variants"]').val(JSON.stringify(item.variants));
      $rowEdit.find('.opcao-preco').text(`R$ ${item.total}`);
      $rowEdit.find('[data-total]').data('total', item.total);
      $rowEdit.find('.opcao-quantidade').text(`${item.quantidade}`);
      $rowEdit.find('.opcao-titulo').text(`${item.titulo}`);
      $rowEdit.data('opcao-titulo', item.titulo);
      $rowEdit.find('.input-opcao-titulo').val(item.titulo);
      $rowEdit.find('.input-opcao-variants').val(JSON.stringify(item.variants));
    }

    // Adicionando opção
    $formAddOpcao.on('submit', function (ev) {
      ev.preventDefault();
      formAddOpcaoSubmit.apply(this, ev);
    });
    function formAddOpcaoSubmit() {
      // Monta json com as variantes
      let variants_list = [];
      const regAtributoNome = /kit_items\[(\d+)\]\[(.*?)\]/;
      $(this)
        .serializeArray()
        .forEach((inputItem) => {
          if (regAtributoNome.test(inputItem.name)) {
            const keyname = inputItem.name.match(regAtributoNome)[2];
            const indexItem = inputItem.name.match(regAtributoNome)[1];
            if (keyname == 'sale_price') {
              inputItem.value = formatMoneyBD(inputItem.value);
            }
            if (!variants_list[indexItem]) {
              variants_list[indexItem] = { [keyname]: inputItem.value };
            } else {
              variants_list[indexItem][keyname] = inputItem.value;
            }
          }
        });
      variants_list = variants_list.filter((item) => item);
      // Adiciona itens
      const fd = new FormData(this);
      const titulo_opcao = fd.get('titulo_opcao');
      const total_opcao = getValorTotalOpcao();
      const quantitade_opcao = getQuantidadeTotalOpcao();
      const item = {
        titulo: titulo_opcao,
        variants: variants_list,
        quantidade: quantitade_opcao,
        total: total_opcao,
      };
      if (item.quantidade == 0) {
        Toast.fire({
          type: 'error',
          title: 'É necessário adicionar pelo menos uma variante.',
        });
      }
      // Ação inserir nova opção
      else if ($modalOpcao.data('acao') == 'insert') {
        addOpcaoLinha(item);
        $modalOpcao.modal('hide');
        Toast.fire({
          type: 'success',
          title: 'Opção adicionada com sucesso.',
        });
      }
      // Ação editar opção
      else if ($modalOpcao.data('acao') == 'update') {
        const idOpcao = $modalOpcao.data('id-opcao');
        editOpcaoLinha(item, idOpcao);
        $modalOpcao.modal('hide');
        Toast.fire({
          type: 'success',
          title: 'Opção editada com sucesso.',
        });
      }
    }

    // Exibe modal para editar opção
    function showModalOpcao(action = 'insert', idOpcao = undefined) {
      $modalOpcao.modal('show');
      if (action == 'insert') {
        $modalOpcao.data('acao', 'insert');
        $modalOpcao.find('.modal-title').text('Cadastrar opção do kit');
        // $formAddOpcao.trigger('reset');
        resetFormOpcao();
        updateButtonsStatus();
      } else if (action == 'update') {
        $modalOpcao.data('acao', 'update').data('id-opcao', idOpcao);
        $modalOpcao.find('.modal-title').text('Editar opção');
        // $formAddOpcao.trigger('reset');
        resetFormOpcao();
        populaFormOpcao(idOpcao);
        updateButtonsStatus();
      }
    }

    // Adicionando opção
    $btnAddOpcao.on('click', function (ev) {
      showModalOpcao('insert');
    });

    function populaFormOpcao(idOpcao) {
      const opcaoJson = getOpcao(idOpcao);

      $modalOpcao.find('#titulo_opcao').val(opcaoJson.titulo);
      opcaoJson.variants.forEach(function (variant, index) {
        const $rowVariant = $listVariantes.find(`[data-sku="${variant.variant_sku}"]`);
        console.log(variant.sale_price);
        const viewMoneyVariant = formatMoneyBR(variant.sale_price);
        $rowVariant.find('.select-variant').prop('checked', true);
        $rowVariant.find('.kit_input_price').val(viewMoneyVariant);
        $rowVariant.find('.kit_input_quantity').val(variant.quantity);
      });
    }

    // Retorna json com os dados da opção
    function getOpcao(opcaoId) {
      const $rowOpcao = $listOpcoes.find(`[data-item=${opcaoId}]`);
      const variantsJson =
        typeof $rowOpcao.data('variants-json') == 'object'
          ? $rowOpcao.data('variants-json')
          : JSON.parse($rowOpcao.data('variants-json'));
      const opcaoTitulo = $rowOpcao.data('opcao-titulo');
      const jsonResult = {
        titulo: opcaoTitulo,
        variants: variantsJson,
      };
      return jsonResult;
    }

    // Ao clicar em um kit para editar
    $listOpcoes.on('click', '[data-edit-opcao]', function (ev) {
      ev.preventDefault();
      resetFormOpcao();
      showModalOpcao('update', $(this).data('edit-opcao'));
    });

    // Ao clicar em um kit para remover
    $listOpcoes.on('click', '[data-remove-opcao]', function (ev) {
      ev.preventDefault();
      const idRemove = $(this).data('remove-opcao');
      resetFormOpcao();
      showConfirm({
        type: 'danger',
        title: 'Confirmar Remoção',
        text: 'Deseja remover esta opção?',
        confirmButtonText: 'Remover',
        cancelButtonText: 'Cancelar',
        callback: function () {
          removeOpcao(idRemove);
        },
      });
    });

    // Remover opção
    function removeOpcao(idRemove) {
      const $rowRemove = $listOpcoes.find(`[data-item=${idRemove}]`);
      $rowRemove.remove();
      if ($listOpcoes.find('tr').length == 0) {
        $tableOpcoesWrp.hide();
      }
    }

    // Deixa o formulário da opção com valores inicaiis
    function resetFormOpcao() {
      $formAddOpcao.trigger('reset');
      let listVariantesObj = $('#variantes_kit_json').val() ? JSON.parse($('#variantes_kit_json').val()) : [];
      const $rowsOpcao = $listVariantes.find('tr');
      $modalOpcao.find('#titulo_opcao').val('');
      $rowsOpcao.each(function (index) {
        $(this).find('.kit_input_price').val(formatMoneyBR(listVariantesObj[index].sale_price));
        $(this).find('.kit_input_quantity').val(listVariantesObj[index].quantity);
      });
    }

    // Desabilita um campo min e máximo se a linha não tiver selecionada
    function desabilitaMinMax() {
      const $rowVariant = $(this);
      if (!$rowVariant.hasClass('linha-atualizadaa')) {
        $rowVariant.addClass('linha-atualizada');
        const $selectVariant = $rowVariant.find('.select-variant');
        const linhaChecada = $selectVariant.is(':checked');
        if (!linhaChecada) {
          const $inputQtd = $rowVariant.find('input.kit_input_quantity');
          const $btnSub = $inputQtd.siblings('.input-group-prepend').find('button');
          const $btnAdd = $inputQtd.siblings('.input-group-append').find('button');

          if (!$btnAdd.hasClass('disabled')) {
            $btnAdd.addClass('disabled');
          }
          if (!$btnSub.hasClass('disabled')) {
            $btnSub.addClass('disabled');
          }
        }
      }
    }

    // Verifica se um campo está habilitado
    function checkHabilitado(in_kit) {
      //const habilitado = $inptDisponibilidade.is(':checked');
      const habilitado = false;
      if (habilitado || in_kit == '1') {
        return true;
      } else {
        return false;
      }
    }

    // Atualiza a imagem do kit
    function updateKitImage(fotoID) {
      for (let imageData of imagesList) {
        if (imageData.id == fotoID) {
          $imageKit.attr('src', imageData['image_large']);
          break;
        }
      }
    }

    // Atualiza botão de quantidade
    function updateQtdBtn($inputQtd) {
      const $inputDisabled = $inputQtd.prop('disabled');
      const $btnSub = $inputQtd.siblings('.input-group-prepend').find('button');
      const $btnAdd = $inputQtd.siblings('.input-group-append').find('button');
      const minEl = Number($inputQtd.attr('min'));
      const maxEl = $inputQtd.attr('max') ? Number($inputQtd.attr('max')) : null;
      const qtd = Number($inputQtd.val());

      // Desabilitado
      if ($inputDisabled) {
        if (maxEl != null && qtd < maxEl) {
          $btnAdd.addClass('disabled');
        }
        if (minEl < qtd) {
          $btnSub.addClass('disabled');
        }
      } else {
        // Habilitado
        if (maxEl == null || qtd < maxEl) {
          $btnAdd.removeClass('disabled');
        }
        if (minEl < qtd) {
          $btnSub.removeClass('disabled');
        }
      }
    }

    // Habilita ou desabilita inputs das opções em função da linha estar checada ou não
    function updateInputsOpcaoStatus($rowOpcao = null) {
      if ($rowOpcao == null) {
        // return;
      }

      const $inputVariants = $rowOpcao.find('.input-opcao-variants');
      const $inputOpcaoTitulo = $rowOpcao.find('.input-opcao-titulo');
      const $selectOpcao = $rowOpcao.find('.select-opcao');

      const opcaoSelecionada = $selectOpcao.is(':checked');
      if (opcaoSelecionada) {
        $inputVariants.prop('disabled', false);
        $inputOpcaoTitulo.prop('disabled', false);
      } else {
        $inputVariants.prop('disabled', true);
        $inputOpcaoTitulo.prop('disabled', true);
      }
    }

    // Habilitta ou desabilita um input em função da linha estar checada ou não
    function updateButtonsStatus($rowVariant = null) {
      if ($rowVariant == null) {
        $tableVariantesWrp.find('tbody tr').each(function (index) {
          $rowVariant = $(this);
          updateButtonsStatus($rowVariant);
        });
        return;
      }
      const $selectVariant = $rowVariant.find('.select-variant');
      // const $inputPrice = $rowVariant.find('input.kit_input_price');
      const $inputQtd = $rowVariant.find('input.kit_input_quantity');
      // const $inputSKU = $rowVariant.find('input.kit_input_sku');
      const $rowInputs = $rowVariant.find('input:not(.select-variant)');

      // Atualiza inputs
      if ($selectVariant.is(':checked')) {
        // $inputPrice.prop('disabled', false);
        // $inputQtd.prop('disabled', false);
        // $inputSKU.prop('disabled', false);
        $rowInputs.prop('disabled', false);
      } else {
        // $inputPrice.prop('disabled', true);
        // $inputQtd.prop('disabled', true);
        // $inputSKU.prop('disabled', true);
        $rowInputs.prop('disabled', true);
      }
      updateQtdBtn($inputQtd);
    }

    function hideAllQtde() {
      $tableVariantesWrp.find('th').last().css('opacity', 0);
      $tableVariantesWrp.find('.number-spinner').css('opacity', 0);
      $('.container-kit-total').removeClass('d-flex').addClass('d-none');
    }

    function showAllQtde() {
      $tableVariantesWrp.find('th').last().css('opacity', 1);
      $tableVariantesWrp.find('.number-spinner').css('opacity', 1);
      $('.container-kit-total').removeClass('d-none').addClass('d-flex');
    }

    // Click na tabela variante
    $tableVariantesWrp.on('click', tableVarianteClick);
    function tableVarianteClick(e) {
      // Clickou no checkbox
      if (e.target.classList.contains('select-variant')) {
        const $selectVariant = $(e.target);
        const $rowVariant = $selectVariant.closest('tr');
        updateButtonsStatus($rowVariant);
      }
    }

    // Ao clicar para aplicar a imagem da variante selecionada
    $('.btn-save-kit-img-product').on('click', function (ev) {
      ev.preventDefault();
      // Verifica se existe alguma foto selecionada
      if ($imagesKitContainer.find('input[name="kit_img"]:checked').length > 0) {
        const fotoID = $imagesKitContainer.find('input[name="kit_img"]:checked').val();
        $inptFotoId.val(fotoID);
        updateKitImage(fotoID);
        $('#modal-img-kit').modal('hide');
      } else {
        Toast.fire({
          type: 'warning',
          title: 'Selecione uma imagem para o kit.',
        });
      }
    });

    // Ao clicar para alterar a imagem do kit
    $imageKit.on('click', function (ev) {
      ev.preventDefault();
      const varianteSlug = $(this).data('handle-kit-img');
      $('#variante_img_slug').val(varianteSlug);
      $('#imgs-kit').find('input[name="variant_img"]').prop('checked', false);
      $('#modal-img-kit').modal('show');
    });
  }

  // Seção da página onde exibe todos os kits do produto
  if ($secaoKits.length > 0) {
    // Ação executada quando um item é removido
    $(document).on('removeItem', kitItemRemoved);
    function kitItemRemoved() {
      setTimeout(() => {
        location.reload();
      }, 1500);
    }
  }

  // Verifica se foram cadastradas opções antes de enviar o formulário
  $('.form-kits .btn-submit').on('click', function (ev) {
    ev.preventDefault();
    if ($('.table-opcoes tr[data-item]').length === 0) {
      Toast.fire({
        type: 'warning',
        title: 'É necessário cadastrar pelo menos uma opção no kit!',
      });
    } else {
      $('.form-kits').submit();
    }
  });
})();
